export default __webpack_public_path__ + "static/media/Staff of Erlik.a6693f93.jpg";